/** *************************************************************
 * Copyright (c) 2006 - 2020, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 01/20/2021
 *
 * @version 0.1
 * Revisions:
 * 01/20/2021 - BW - Initial Creation
 *
 * Description/Purpose:
 * Payment Profile DTO - needs to get converted via JSON back to Java
 ************************************************************** */

function PaymentProfileDTO(customerProfileId, accountNumber, expirationDate) {
  this.customerProfileId = customerProfileId;
  this.accountNumber = accountNumber;
  this.expirationDate = expirationDate;
}

export default PaymentProfileDTO;
